/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knotty_Real_Dog_TypeInputs */

const en_knotty_real_dog_type = /** @type {(inputs: Knotty_Real_Dog_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appearance`)
};

const de_knotty_real_dog_type = /** @type {(inputs: Knotty_Real_Dog_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erscheinungsbild`)
};

/**
* | output |
* | --- |
* | "Appearance" |
*
* @param {Knotty_Real_Dog_TypeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const knotty_real_dog_type = /** @type {((inputs?: Knotty_Real_Dog_TypeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knotty_Real_Dog_TypeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_knotty_real_dog_type(inputs)
	return de_knotty_real_dog_type(inputs)
});